import { render } from "./HemerotecaGaleria.vue?vue&type=template&id=8e98e04c&scoped=true&lang=html"
import script from "./HemerotecaGaleria.vue?vue&type=script&lang=js"
export * from "./HemerotecaGaleria.vue?vue&type=script&lang=js"

import "./HemerotecaGaleria.vue?vue&type=style&index=0&id=8e98e04c&scoped=true&lang=scss"

import exportComponent from "/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8e98e04c"]])

export default __exports__